module.exports = __webpack_public_path__ + "static/11-37335987734e1520e730a747d7b48895.jpg";